import {message} from "antd";
import AgencyMaintainService from "../../agency_maintain/service";

export const RUN_MONITOR_REAL_TIME_DATA_TABLE_LOADING = "RUN_MONITOR_REAL_TIME_DATA_TABLE_LOADING"; //  实时数据表格加载中
export const RUN_MONITOR_REAL_TIME_DATA_TABLE_INFO = "RUN_MONITOR_REAL_TIME_DATA_TABLE_INFO"; // 工况查询表格加载中
export const RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO_LOADING = "RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO_LOADING"; // 设置列表加载中
export const RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO = "RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO"; // 设置列表获取
export const RUN_MONITOR_REAL_TIME_SETTING_MODAL_VISIBLE = "RUN_MONITOR_REAL_TIME_SETTING_MODAL_VISIBLE"; // 设置模态框的可见性
export const RUN_MONITOR_REAL_TIME_SETTING_MODAL_SAVING_LOADING = "RUN_MONITOR_REAL_TIME_SETTING_MODAL_SAVING_LOADING"; // 设置模态框的可见性
export const RUN_MONITOR_REAL_TIME_SET_SEARCH_PARAMS = "RUN_MONITOR_REAL_TIME_SET_SEARCH_PARAMS"; // 设置查询节点参数
export const RUN_MONITOR_REAL_TIME_HISTORY_CURVE_LOADING = "RUN_MONITOR_REAL_TIME_HISTORY_CURVE_LOADING"; // 历史曲线加载中
export const RUN_MONITOR_REAL_TIME_SET_SELECTED_DATA = "RUN_MONITOR_REAL_TIME_SET_SELECTED_DATA"; // 设置选中的数据项
export const RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA = "RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA"; // 历史曲线数据
export const RUN_MONITOR_REAL_TIME_RESET_DATA = "RUN_MONITOR_REAL_TIME_RESET_DATA"; // 重置曲线数据

/**
 * 获取实时数据
 * @param params {superiorId: 树节点id ,  ceResSortNo: 树节点类型}
 */
export const getRealTimeData = (params) => {
    return (dispatch, getState) => {
        dispatch(setRealTimeTableIsLoading(true))
        AgencyMaintainService.runMonitorRealTimeService.getRealTimeData({
            ...params,
            type: "1"
        }).then(json => {
            if(json.code == 0){
                if(json.data.leftList.length > 0 && getState().agencyMaintainData.realTimeData.selectedData.measCode == null){
                    if(json.data.threePhase){
                        dispatch(setSelectedData(json.data.leftList[0].mica == null ? '--':json.data.leftList[0].mica.split(",")[0], json.data.leftList[0].measItemType, "A相" + json.data.leftList[0].dimyAlias, json.data.leftList[0].measItemUnit));
                        }else{
                        dispatch(setSelectedData(json.data.leftList[0].measItemCode, json.data.leftList[0].measItemType, json.data.leftList[0].measItemAlias,  json.data.leftList[0].measItemUnit))

                    }
                }
                dispatch({
                    type: RUN_MONITOR_REAL_TIME_DATA_TABLE_INFO,
                    leftList: json.data.leftList ? json.data.leftList : [],
                    rightList: json.data.rightList ? json.data.rightList : [],
                    dateTime: json.data.dateTime ? json.data.dateTime : [],
                    threePhase:json.data.threePhase,
                    devMeterInfo:json.data.meterInfo
                })
            }else{
                message.error(json.msg);
                dispatch({
                    type: RUN_MONITOR_REAL_TIME_DATA_TABLE_INFO,
                    leftList:  [],
                    rightList:  [],
                    dateTime: [],
                    devMeterInfo: {},
                })
                dispatch({
                    type: RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA,
                    curve: [],
                    listTime: [],
                    data:[]
                })
            }
        }).catch(e => {
            console.error("获取实时数据异常:" + e);
            message.error("获取实时数据失败");
        }).then(() => dispatch(setRealTimeTableIsLoading(false)));
    }
}

/**
 * 获取设置列表
 */
export const getSettingList = (params) => {
    return dispatch => {
        dispatch(setRealTimeSettingListLoading(true))
        AgencyMaintainService.runMonitorRealTimeService.getRealTimeData({
            ...params,
            type: "2"
        }).then(json => {
            if(json.code == 0){
                dispatch({
                    type: RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO,
                    settingList: json.data.settingList
                })
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("获取设置列表异常:" + e);
            message.error("获取设置列表失败");
        }).then(() => dispatch(setRealTimeSettingListLoading(false)));
    }
}

/**
 * 设置模态框是否可见
 */
export const setModalVisible = (visible) => {
    return {
        type: RUN_MONITOR_REAL_TIME_SETTING_MODAL_VISIBLE,
        visible: visible
    }
}

/**
 * 保存配置
 */
export const saveSetting = (searchParams, list) => {
    return dispatch => {
        dispatch(setRealTimeModalSavingLoading(true))
        AgencyMaintainService.runMonitorRealTimeService.saveSetting({
            superiorId: searchParams.superiorId,
            rightContainer: list
        }).then(json => {
            dispatch(setRealTimeModalSavingLoading(false))
            if(json.code == 0){
                dispatch(setModalVisible(false));
                message.success("保存成功");
                dispatch(getRealTimeData(searchParams));
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("保存设置异常:" + e);
            message.error("保存设置失败");
        });
    }
}


/**
 * 获取历史曲线
 * @param params  superiorId, dateTime, dateType, insAndCum, measCode
 */
export const getHistoryCurve = (params) => {
    return dispatch => {
        dispatch(setHistoryCurveLoading(true))
        AgencyMaintainService.runMonitorRealTimeService.getHistoryCurve(params).then(json => {
            if(json.code == 0){
                dispatch({
                    type: RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA,
                    curve: json.data.curve == null ? [] : json.data.curve ,
                    listTime: json.data.listTime == null ? [] : json.data.listTime,
                    data: json.data
                })
            }else{
                message.error(json.msg);
                dispatch({
                    type: RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA,
                    curve: [],
                    listTime: [],
                    data:[]
                })
            }
        }).catch(e => {
            dispatch({
                type: RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA,
                curve: [],
                listTime: [],
                data:[]
            })
            console.error("加载历史曲线异常:" + e);
            message.error("加载历史曲线失败");
        }).then(() => dispatch(setHistoryCurveLoading(false)));
    }
}

/**
 * 设置选中的数据
 */
export const setSelectedData = (measCode, insAndCum, title, unit) => {
    return {
        type: RUN_MONITOR_REAL_TIME_SET_SELECTED_DATA,
        measCode: measCode,
        insAndCum: insAndCum,
        title: title,
        unit: unit
    }
}


/**
 * 设置查询节点参数
 */
export const setSearchParam = (params) => {
    return {
        type: RUN_MONITOR_REAL_TIME_SET_SEARCH_PARAMS,
        params: params
    }
}

/**
 * 历史曲线加载中
 */
const setHistoryCurveLoading = (isLoading) => {
    return {
        type: RUN_MONITOR_REAL_TIME_HISTORY_CURVE_LOADING,
        isLoading: isLoading
    }
}

/**
 * 设置实时数据表格加载中
 * @param isLoading true:loading
 */
const setRealTimeTableIsLoading = (isLoading) => {
    return {
        type: RUN_MONITOR_REAL_TIME_DATA_TABLE_LOADING,
        isLoading: isLoading
    }
}

/**
 * 设置列表加载中
 */
const setRealTimeSettingListLoading = (isLoading) => {
    return {
        type: RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO_LOADING,
        isLoading: isLoading
    }
}

/**
 * 模态框保存加载中
 */
const setRealTimeModalSavingLoading = (isLoading) => {
    return {
        type: RUN_MONITOR_REAL_TIME_SETTING_MODAL_SAVING_LOADING,
        isLoading: isLoading
    }
}
/**
 * 重置曲线数据
 */
export  const resetRealTimeData = () => {
    return {
        type: RUN_MONITOR_REAL_TIME_RESET_DATA
    }
}
